import { useCallback, useContext, useEffect, useState } from "react";
import {
  BurgerMenu,
  BurgerMenuItem,
  HeaderMenuWrapper,
  HeaderWrapper,
  Logo,
} from "./Header.styled";
import { DrawerContext } from "../ReactContext/DrawerContext";
import { CustomBurgerIcon } from "./CustomBurgerIcon";
import { useMediaQuery } from "../../utils/useMediaQuery";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useScrollDirection } from "../../utils/useScrollDirection";
import { BurgerSocials } from "./BurgerSocials/BurgerSocials";

const menuItems = [
  { id: "About", label: "01. About" },
  { id: "Work", label: "02. Work" },
  { id: "CaseStudy", label: "03. Case Study" },
  { id: "Contact", label: "04. Contact" },
];

const Header = ({ showSidebarButton = true }) => {
  const { showSidebar, toggleSidebar } = useContext(DrawerContext);
  const isSmallerThan800 = useMediaQuery("(max-width: 800px)");

  /*This selectedMenuItem state variable can be used to track which menu item
  is currently active, and apply specific styles or behavior to the active item.*/
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const handleMenuItemClick = (itemId) => {
    setSelectedMenuItem(itemId);
  };

  /* Close when clicked outside BurgerMenu */
  useEffect(() => {
    const handleClickOutside = (event) => {
      const burgerButton = document.getElementById("nav-icon3");
      if (
        showSidebar &&
        event.target !== burgerButton &&
        !burgerButton.contains(event.target) &&
        !event.target.closest(".BurgerMenu")
      ) {
        toggleSidebar();
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showSidebar, toggleSidebar]);

  /* Add class .open to the nav-icon3 and toggle the sidebar with toggleSidebar() */
  const toggleClassOnClick = () => {
    const burgerIcon = document.getElementById("nav-icon3");
    burgerIcon.addEventListener("click", () => {
      burgerIcon.classList.toggle("open");
      toggleSidebar();
    });
  };
  /* Check if user is on home page.. */
  let location = useLocation();

  const isHomePage = useCallback(() => {
    const currPathname = location.pathname;
    const newPathname = currPathname.slice(1, currPathname.length);
    return newPathname === "" ? true : false;
  }, [location]);

  const isScrollingDown = useScrollDirection();

  if (isHomePage()) {
    return (
      <HeaderWrapper
        className="HeaderWrapper"
        isScrollingDown={isScrollingDown}
        // initial={{ y: -200 }}
        // animate={{ y: 0 }}
        // transition={{ duration: 1 }}
      >
        <Logo
          href="/"
          className="prevent-select"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1, rotate: 360 }}
          // transition={{ duration: 1 }}
        >
          VHT<span>.</span>
        </Logo>
        {isSmallerThan800 ? (
          showSidebarButton && (
            <div>
              <CustomBurgerIcon onClick={toggleClassOnClick} />
              <BurgerMenu
                className="BurgerMenu"
                id="burgerMenu"
                isOpen={showSidebar}
              >
                {menuItems.map((item) => (
                  <BurgerMenuItem
                    key={item.id}
                    onClick={toggleSidebar}
                    className="prevent-select"
                  >
                    <a
                      href={`#${item.id}`}
                      onClick={() => handleMenuItemClick(item.id)}
                    >
                      <span
                        style={{ fontSize: "12px", color: "var(--main-color)" }}
                      >
                        {item.label.substring(0, 3)}
                      </span>
                      <span
                        className={
                          selectedMenuItem === item.id ? "ActiveSection" : ""
                        }
                        style={{ fontSize: "16px" }}
                      >
                        {item.label.substring(3)}
                      </span>
                    </a>
                  </BurgerMenuItem>
                ))}
                <BurgerSocials />
              </BurgerMenu>
            </div>
          )
        ) : (
          <HeaderMenuWrapper className="HeaderMenuWrapper prevent-select">
            {menuItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  // className={selectedMenuItem === item.id ? "ActiveSection" : ""}
                  onClick={() => handleMenuItemClick(item.id)}
                >
                  {/* {item.label} */}
                  <span
                    // className={selectedMenuItem === item.id ? "ActiveSection" : ""}
                    style={{ fontSize: "12px", color: "var(--main-color)" }}
                  >
                    {item.label.substring(0, 3)}
                  </span>
                  <span
                    className={
                      selectedMenuItem === item.id ? "ActiveSection" : ""
                    }
                    style={{ fontSize: "16px" }}
                  >
                    {item.label.substring(3)}
                  </span>
                </a>
              </li>
            ))}
          </HeaderMenuWrapper>
        )}
      </HeaderWrapper>
    );
  }
  return (
    <HeaderWrapper className="HeaderWrapper" isScrollingDown={isScrollingDown}>
      <Logo href="/" className="prevent-select">
        VHT<span>.</span>
      </Logo>
      {isSmallerThan800 ? (
        showSidebarButton && (
          <div>
            <CustomBurgerIcon onClick={toggleClassOnClick} />
            <BurgerMenu
              className="BurgerMenu"
              id="burgerMenu"
              isOpen={showSidebar}
            >
              {menuItems.map((item) => (
                <BurgerMenuItem
                  key={item.id}
                  onClick={toggleSidebar}
                  className="prevent-select"
                >
                  <HashLink
                    to={`/#${item.id}`}
                    scroll={(el) => {
                      // console.log("Hash hash ", { el });
                      return el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                    onClick={() => {
                      handleMenuItemClick(item.id);
                      // scrollToSection(item.id);
                      // GoToSectionWhenClick(item.id);
                    }}
                  >
                    <span
                      style={{ fontSize: "12px", color: "var(--main-color)" }}
                    >
                      {item.label.substring(0, 3)}
                    </span>
                    <span
                      className={
                        selectedMenuItem === item.id ? "ActiveSection" : ""
                      }
                      style={{ fontSize: "16px" }}
                    >
                      {item.label.substring(3)}
                    </span>
                  </HashLink>
                </BurgerMenuItem>
              ))}
            </BurgerMenu>
          </div>
        )
      ) : (
        <HeaderMenuWrapper className="HeaderMenuWrapper prevent-select">
          {menuItems.map((item) => (
            <li key={item.id}>
              <a
                href="/"
                // className={selectedMenuItem === item.id ? "ActiveSection" : ""}
                onClick={() => {
                  handleMenuItemClick(item.id);
                  // scrollToSection(item.id);
                  // GoToSectionWhenClick(item.id);
                }}
              >
                {/* {item.label} */}
                <span
                  // className={selectedMenuItem === item.id ? "ActiveSection" : ""}
                  style={{ fontSize: "12px", color: "var(--main-color)" }}
                >
                  {item.label.substring(0, 3)}
                </span>
                <span
                  className={
                    selectedMenuItem === item.id ? "ActiveSection" : ""
                  }
                  style={{ fontSize: "16px" }}
                >
                  {item.label.substring(3)}
                </span>
              </a>
            </li>
          ))}
        </HeaderMenuWrapper>
      )}
    </HeaderWrapper>
  );
};

export default Header;
